import React from "react";

/* Was an uncontrolled stack of antd Row/Col with keyless Checkboxes, rendered
   inline on the create page. The recurrence now lives in the Custom modal, so
   this is a controlled panel of it. Previous version in git history. */

/**
 * Week panel of the Custom recurrence modal.
 *
 *   value: { interval, days: ["mon", …] }
 *
 * Styles come from CustomRecurrenceModal.css, which the modal imports.
 */

const DAYS = [
  { value: "mon", label: "Mon" },
  { value: "tue", label: "Tue" },
  { value: "wed", label: "Wed" },
  { value: "thu", label: "Thu" },
  { value: "fri", label: "Fri" },
  { value: "sat", label: "Sat" },
  { value: "sun", label: "Sun" },
];

export default function WeeklyForm({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });

  const toggleDay = (day) => {
    const days = value.days.indexOf(day) !== -1 ? value.days.filter((d) => d !== day) : value.days.concat(day);
    set({ days });
  };

  return (
    <div className="crm-section">
      <div className="crm-row">
        <span className="crm-row-label">Recur every</span>
        <input
          type="number"
          min="1"
          className="crm-num"
          value={value.interval}
          onChange={(e) => set({ interval: e.target.value })}
        />
        <span className="crm-row-label">week(s) on:</span>
      </div>

      <div className="crm-days">
        {DAYS.map((day) => (
          <label className="crm-day" key={day.value}>
            <input type="checkbox" checked={value.days.indexOf(day.value) !== -1} onChange={() => toggleDay(day.value)} />
            <span>{day.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
